import type {
  CredentialGroup,
  CredentialsConfig,
} from 'src/types/data-integration';


export const CREDENTIAL_AUDIT_ACTIONS = {
  CREATE: 'Created',
  UPDATE: 'Updated',
  REMOVE: 'Removed',
  VALIDATE: 'Validated',
  ERROR: 'Error',
} as const;

export const VISITED_DATA_INTEGRATION_PAGE = 'Data Integration Page Visited';

export const DATA_INTEGRATION_CLICK_EVENTS = {
  'Edit Connection': false,
  'Clicking Save Changes of Edit Connection': false,
  'Clicking Add Credentials': false,
  'Clicking Add Credentials and Connect ATS': false,
  'Clicking Check Connection': false,
  'Clicking Activity Log': false,
} as const;
export const formatTimestamp = (timestamp: string): string => {
  try {
    const date = new Date(timestamp);

    if (isNaN(date.getTime())) {
      throw new Error('Invalid timestamp');
    }

    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    })
      .format(date)
      .replace(',', ' @');
  } catch (error: any) {
    console.error('Error formatting timestamp:', error.message);
    return 'Invalid Date';
  }
};

export const formatTime = (timestamp: string): string => {
  try {
    const date = new Date(timestamp);

    if (isNaN(date.getTime())) {
      throw new Error('Invalid timestamp');
    }

    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    }).format(date);
  } catch (error: any) {
    console.error('Error formatting time:', error.message);
    return 'Invalid Time';
  }
};

export const formatToDayMonth = (timestamp: string): string => {
  try {
    const date = new Date(timestamp);

    if (isNaN(date.getTime())) {
      throw new Error('Invalid timestamp');
    }

    return new Intl.DateTimeFormat('en-US', {
      weekday: 'short',
      month: 'long',
      day: 'numeric',
    }).format(date);
  } catch (error: any) {
    console.error('Error formatting day and month:', error.message);
    return 'Invalid Date';
  }
};

export const mergeCredentialsWithMeta = (
  ob1: CredentialsConfig,
  ob2: CredentialsConfig,
): CredentialsConfig => {
  const merged: CredentialsConfig = {};

  for (const key in ob1) {
    if (ob1.hasOwnProperty(key)) {
      merged[key] = ob1[key].map((item1) => {
        const item2 = ob2[key]?.find(
          (item: CredentialGroup) =>
            item.credentialsGroup === item1.credentialsGroup,
        );

        if (item2) {
          const mergedFields = item1.fields.map((field1) => {
            const field2 = item2.fields.find(
              (field) => field.fieldName === field1.fieldName,
            );
            return {
              ...field1,
              fieldValue: field2?.fieldValue || '',
            };
          });

          return {
            ...item1,
            ...item2,
            fields: mergedFields,
          };
        }
        return {
          ...item1,
          fields: item1.fields.map((field) => {
            return {...field, fieldValue: ''};
          }),
        };
      });
    }
  }

  return merged;
};

export const hasArnieEntityCredGroup = (data: CredentialsConfig): boolean => {
  return data
    ? Object.keys(data).some((key) =>
        data[key].some(
          (item) => item.credentialsGroup === 'ArnieEntityAPICredentials',
        ),
      )
    : false;
};

export const extractTime = (dateString: string): string => {
  const match = dateString.match(/\d{1,2}:\d{2} [APM]{2}/);
  return match ? match[0] : '-';
};
